import { create } from 'zustand';

import { type AnyModalStore, registerModalOccupant } from '@/shared/lib/modal';

import type { TrialPaywallVariant } from '../lib/types';

type TrialPaywallExperimentAssignment = {
  userId: string;
  variant: TrialPaywallVariant;
};

type TrialPaywallVariantStore = {
  assignment: null | TrialPaywallExperimentAssignment;
  isPaywallShown: boolean;
  markPaywallShown: () => void;
  setAssignment: (assignment: TrialPaywallExperimentAssignment) => void;
};

export const useTrialPaywallVariantStore = create<TrialPaywallVariantStore>((set) => ({
  assignment: null,
  isPaywallShown: false,
  markPaywallShown: () => set({ isPaywallShown: true }),
  setAssignment: (assignment) => set({ assignment, isPaywallShown: false }),
}));

const isPaywallPending = ({ assignment, isPaywallShown }: TrialPaywallVariantStore) =>
  assignment?.variant === 'B' && !isPaywallShown;

export const trialPaywallPendingOccupant: AnyModalStore = {
  subscribe: (listener) =>
    useTrialPaywallVariantStore.subscribe((state, previous) =>
      listener({ isOpen: isPaywallPending(state) }, { isOpen: isPaywallPending(previous) }),
    ),
  getState: () => {
    const state = useTrialPaywallVariantStore.getState();

    return { close: state.markPaywallShown, isOpen: isPaywallPending(state) };
  },
};

registerModalOccupant(trialPaywallPendingOccupant);
